<div class="info-card mb-4">
  <div class="card-header">
    <span class="card-title mb-0"> {{ title }} </span>

    <button
      type="button"
      mat-raised-button
      matTooltip="Limit 10,000"
      matTooltipPosition="above"
      [disabled]="fileLoading"
      (click)="downloadData()"
    >
      <span class="button-label-with-icon">
        @if (fileLoading) {
          <mat-spinner diameter="20" />
        } @else {
          <mat-icon class="me-2">cloud_download</mat-icon>
        }
        Download Excel File
      </span>
    </button>
  </div>

  <div class="card-info">
    <kendo-grid
      #usageGrid="kendoGrid"
      class="w-100"
      [data]="gridData"
      [pageable]="true"
      [skip]="skip * 1"
      [pageSize]="take"
      [columnMenu]="{ columnChooser: false }"
      [height]="400"
      [size]="'small'"
      (dataStateChange)="dataStateChange($event)"
    >
      @if (reportName === 'PM Rep Top Policy Review') {
        <kendo-grid-column width="75">
          <ng-template let-dataItem kendoGridCellTemplate>
            <button
              type="button"
              mat-icon-button
              color="primary"
              matTooltip="View Policy"
              (click)="handleRowClick(dataItem)"
            >
              <mat-icon>preview</mat-icon>
            </button>
          </ng-template>
        </kendo-grid-column>
      }
      @for (header of gridData.headers; track $index) {
        <kendo-grid-column
          [field]="header.DataField"
          [title]="header.Label"
          [sortable]="header.Sort"
          [filterable]="header.Filter"
          [hidden]="header.Hidden"
        >
          <ng-template let-dataItem kendoGridCellTemplate>
            @if (
              this.configType === 'carrier-top-performers' &&
              header.DataField === 'contractCount'
            ) {
              <button
                type="button"
                matButton
                matTooltip="Launch to Book Management"
                (click)="handleItemClick(dataItem, 'carrier-policy-details')"
              >
                <mat-icon>launch</mat-icon>
                {{ dataItem[header.DataField] | number }}
              </button>
            } @else if (header.DataField === 'contractCount') {
              <button
                type="button"
                matButton
                matTooltip="Launch to Book Management"
                (click)="handleItemClick(dataItem, 'book-management')"
              >
                <mat-icon>launch</mat-icon>
                {{ dataItem[header.DataField] | number }}
              </button>
            } @else if (header.DataField === 'npn' && canLaunchToRepView) {
              <button
                type="button"
                matButton
                matTooltip="Launch and Filter in Rep View"
                (click)="
                  handleItemClick(dataItem, 'book-management/rep-reports')
                "
              >
                <mat-icon>launch</mat-icon>{{ dataItem[header.DataField] }}
              </button>
            } @else if (header['Type'] === 'curr') {
              {{ dataItem[header.DataField] | currency }}
            } @else if (header['Type'] === 'double') {
              {{ dataItem[header.DataField] | number }}
            } @else {
              {{ dataItem[header.DataField] }}
            }
          </ng-template>
        </kendo-grid-column>
      }
      <ng-template
        let-totalPages="totalPages"
        let-currentPage="currentPage"
        kendoPagerTemplate
      >
        <kendo-pager-prev-buttons />
        <kendo-pager-numeric-buttons [buttonCount]="5" />
        <kendo-pager-next-buttons />
        <kendo-pager-input />
        <kendo-pager-info />
        <kendo-pager-page-sizes [pageSizes]="pageSizeOptions" />
      </ng-template>
    </kendo-grid>

    <ngx-loading
      [show]="loading$ | async"
      [config]="{
        fullScreenBackdrop: false,
      }"
    />
  </div>
</div>
